// =============================================
// COMPONENTE: SchedulerNode - Nó de Agendamento
// =============================================
// Arquivo: SchedulerNode.tsx
// Descrição: Nó para executar fluxos em horários agendados (cron)
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Calendar, Clock, Repeat } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const SchedulerNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    scheduleType = 'cron',
    cronExpression,
    frequency,
    time,
    timezone = 'America/Sao_Paulo',
    enabled = true,
    description,
    actions
  } = data;

  const getScheduleLabel = () => {
    switch (scheduleType) {
      case 'cron':
        return cronExpression || '0 9 * * *';
      case 'daily':
        return `Diariamente às ${time || '09:00'}`;
      case 'weekly':
        return `Semanalmente ${frequency || 'Segunda'}`;
      case 'monthly':
        return `Mensalmente dia ${frequency || '1'}`;
      case 'interval':
        return `A cada ${frequency || '30'} minutos`;
      default:
        return 'Agendado';
    }
  };

  const getScheduleIcon = () => {
    switch (scheduleType) {
      case 'cron':
      case 'daily':
        return <Clock size={18} />;
      case 'weekly':
      case 'monthly':
        return <Calendar size={18} />;
      case 'interval':
        return <Repeat size={18} />;
      default:
        return <Calendar size={18} />;
    }
  };

  return (
    <div className={`flow-node scheduler-node ${selected ? 'selected' : ''} ${!enabled ? 'disabled' : ''}`}>
      <div className="node-header scheduler-header">
        {getScheduleIcon()}
        <span className="node-title">{label || 'Scheduler'}</span>
      </div>

      <div className="node-body">
        <div className="node-detail">
          <span className="node-detail-text schedule-info">
            ⏰ {getScheduleLabel()}
          </span>
        </div>
        {timezone && (
          <div className="node-badge">
            🌍 {timezone}
          </div>
        )}
        {!enabled && (
          <div className="node-badge warning">
            ⏸️ Pausado
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default SchedulerNode;
